export const bookingChangesContants = {
    RESET: 'RESET',
    BOOKINGCHANGES_FETCHING: 'BOOKINGCHANGES_FETCHING',
    BOOKINGCHANGES_FETCHED: 'BOOKINGCHANGES_FETCHED',
    BOOKINGCHANGES_SUBMITTING: 'BOOKINGCHANGES_SUBMITTING',
    BOOKINGCHANGES_SUBMITTED: 'BOOKINGCHANGES_SUBMITTED',
    GET_BOOKINGREF: 'GET_BOOKINGREF',
    GET_REVISION_LIST: 'GET_REVISION_LIST',
    GET_REVISION_BY_ID: 'GET_REVISION_BY_ID',
    GET_APPROVED_REVISION_BY_ID: 'GET_APPROVED_REVISION_BY_ID',
    BOOKINGCHANGES_GENERATE_SI: 'BOOKINGCHANGES_GENERATE_SI',
    DOWNLOAD_APPROVED_BC: 'DOWNLOAD_APPROVED_BC',
}